(function () {
  "use strict";

  var COOKIE = "_wms_src";
  var MAX_AGE = 30 * 24 * 60 * 60; // 30 days
  var READ_SRC = "SLACK"; // value set when a blog article is read
  var MIN_READ_SECONDS = 5; // visible time on article required to count as a read
  var MAX_LEN = 100; // cap stored value length
  var PARAM_PRIORITY = ["v", "src"]; // v= wins over src=

  function clean(val) {
    if (val == null) return null;
    val = String(val).trim();
    if (!val) return null;
    return val.length > MAX_LEN ? val.slice(0, MAX_LEN) : val;
  }

  // Case-insensitive lookup (?V=, ?Src= etc.), first non-empty value wins
  function findParam(query) {
    if (!query) return null;
    var found = {};
    try {
      new URLSearchParams(query).forEach(function (value, key) {
        var k = key.toLowerCase();
        if (found[k] == null && clean(value)) found[k] = clean(value);
      });
    } catch (e) {
      return null;
    }
    for (var i = 0; i < PARAM_PRIORITY.length; i++) {
      if (found[PARAM_PRIORITY[i]]) return found[PARAM_PRIORITY[i]];
    }
    return null;
  }

  function cookieDomain() {
    var h = window.location.hostname;
    return /(^|\.)mggolf\.com$/i.test(h) ? ";domain=.mggolf.com" : "";
  }

  function getCookie() {
    try {
      var m = document.cookie.match("(?:^|; )" + COOKIE + "=([^;]*)");
      if (!m) return null;
      try {
        return clean(decodeURIComponent(m[1]));
      } catch (e) {
        return clean(m[1]);
      } // malformed encoding: use raw value rather than crash
    } catch (e) {
      return null;
    }
  }

  function setCookie(val) {
    try {
      document.cookie =
        COOKIE +
        "=" +
        encodeURIComponent(val) +
        ";path=/;max-age=" +
        MAX_AGE +
        cookieDomain() +
        ";SameSite=Lax" +
        (window.location.protocol === "https:" ? ";Secure" : "");
    } catch (e) {
      /* cookies blocked */
    }
  }

  function pushToCart(val) {
    try {
      var attrs = {};
      attrs[COOKIE] = val;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true, // survives an immediate navigation / bounce
      }).catch(function () {
        /* silent */
      });
    } catch (e) {
      /* fetch unavailable */
    }
  }

  try {
    // 1) Capture v= / src= from the query string, falling back to the hash (#v=...)
    var srcVal =
      findParam(window.location.search) ||
      findParam((window.location.hash || "").replace(/^#\/?/, ""));
    if (srcVal) setCookie(srcVal);

    // 2) Sync to cart. Use the URL value directly too, in case cookies are blocked.
    var current = srcVal || getCookie();
    if (current) {
      pushToCart(current);
      return;
    }

    // 3) Blog read tracking: individual article pages only, nothing captured yet
    var path = window.location.pathname;
    if (!/\/blogs\/[^\/]+\/[^\/]+/.test(path) || /\/tagged\//.test(path))
      return;

    var visibleMs = 0;
    var visibleSince = document.hidden ? null : Date.now();
    var done = false;
    var timer;

    var check = function () {
      var total = visibleMs + (visibleSince ? Date.now() - visibleSince : 0);
      if (done || total < MIN_READ_SECONDS * 1000) return;
      done = true;
      clearInterval(timer);
      if (getCookie()) return;
      setCookie(READ_SRC);
      pushToCart(READ_SRC);
    };

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (visibleSince) {
          visibleMs += Date.now() - visibleSince;
          visibleSince = null;
        }
      } else {
        visibleSince = Date.now();
      }
    });

    timer = setInterval(check, 1000);
  } catch (e) {
    /* never break the page */
  }
})();
